import React from 'react';
import ReactDOM from 'react-dom';
import AppURL from './common_assets/URL';
import './index.scss';
import App from './views/App';
import { HashRouter, Route} from "react-router-dom";

const MainApp = () => {
    return (
        <HashRouter >
            <Route path={AppURL.ROOT_PATH} component={App} />
        </HashRouter >
    );
};

ReactDOM.render(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
